(function ($) {

	$(window).scroll(function (event) {

		var currentScroll = $(window).scrollTop();
		if($('.video-container').length) {
			var hideMenuOnScroll = $('.video-container').outerHeight();

			if (currentScroll > hideMenuOnScroll) {
				$('#header').addClass('header-scrolled');
			} else {
				$('#header').removeClass('header-scrolled');
			}
		}


	});

})(jQuery);